<template lang="pug">
	.invoice-payment.flex-col.space-large.dx-card
		.flex-row.center
			img(:src="require('assets/logo_transparent.png')" height="60px")
		.flex-col.space-large(v-if="!success")
			Loader(v-if="!invoice", text="Loading")
			template(v-else-if="invoice && invoice.Oid")
				.flex-col
					.font-small.upper.center.grey {{$tCaption('Invoice payment')}}
					.font-large.upper.center {{$tCaption('Invoice')}} {{`#${invoice.InvoiceNumber}`}}
				.flex-row.space-large
					.flex-col
						.font-small.grey.upper {{$tCaption('Price')}}
						.flex-row.font-big {{$formatNumber(invoice.Gross)}} {{$currencySign(invoice.CurrencyCode)}}
					.flex-col
						.font-small.grey.upper {{$tCaption('Tax')}}
						.flex-row.font-big {{$formatNumber(invoice.Tax)}}%
				.flex-col
					.font-small.grey.upper {{$tCaption('Total amount')}}
					.flex-row.font-large {{$formatNumber(invoice.Total)}} {{$currencySign(invoice.CurrencyCode)}}
				DxButton(v-if="invoice.Status === 0", type="success", icon="fas fa-arrow-right", :text="$tCaption('Pay')", @click="pay", :disabled="isLoading")
				template(v-else)
					.flex-row
						.badge.flex-row.upper.center.grey.align-center.space
							i.fas.fa-check
							span {{$tCaption('Payed')}}
					DxButton(type="success", icon="fas fa-arrow-right", :text="$tCaption('Continue')", @click="() => $router.push('/home')")
		template(v-else)
			span {{$tCaption('Thank you, your payment has been successfully processed.')}}
			DxButton(type="success", icon="fas fa-arrow-right", :text="$tCaption('Continue')", @click="() => $router.push(`/${decodeURIComponent(redirectTo || 'home')}`)")
</template>

<script>
	import DxButton from 'devextreme-vue/button';
	import Loader from 'app-core/Loader.vue';
	import dynamic from 'dynamic';

	export default {
		translationCategory: 'invoice.InvoicePayment',
		name: 'invoice-payment',
		components: {
			DxButton, Loader
		},
		props: ['invoiceId', 'tokenId', 'success', 'redirectTo'],
		data() {
			return {
				invoice: null,
				isLoading: false
			};
		},
		mounted() {
			if (__DEBUG__)
				window.invoicePayment = this;
			if (!this.success)
				this.loadInvoiceInfo();
		},
		watch: {
			incoiceId() {
				this.loadInvoiceInfo();
			},
			tokenId() {
				this.loadInvoiceInfo();
			}
		},
		methods: {
			loadInvoiceInfo() {
				this.invoice = null;
				if (!this.invoiceId || !this.tokenId) return;
				this.isLoading = true;
				this.$Data.getExternalApi('InvoicePay/GetInvoice', `invoiceId=${this.invoiceId}&tokenId=${this.tokenId}`).then(r => {
					this.invoice = r;
				}).finally(() => this.isLoading = false);
			},
			pay() {
				if (!this.invoiceId || !this.tokenId) return;
				this.isLoading = true;
				this.$Data.getExternalApi('InvoicePay/CreatePaymentSession', `invoiceId=${this.invoiceId}&tokenId=${this.tokenId}&backUrl=${encodeURIComponent(window.location.href)}&successUrl=${encodeURIComponent(`${window.location.href}&success=true`)}`).then(session => {
					if (session.Success) {
						this.$Data.getStripeKey().then(key => {
							dynamic.loadOnce(['https://js.stripe.com/v3/'], 'js').then(() => {
								var stripe = Stripe(key);
								stripe.redirectToCheckout({
									sessionId: session.Data
								})
								.then(handleResult).catch(() => this.$notifyError(error, 5000));
							});
						}).catch(() => this.isLoading = false);
					} else {
						this.isLoading = false
						this.$notifyError(r.ErrorMessage);
					}
				}).catch(() => this.isLoading = false)
			}
		}
	};
</script>
<style lang='scss'>
	.invoice-payment {

	}
</style>
